<template>
	<div class="mt-3 pagination-wrapper">
		<div class="pagination-desktop">
			<PaginatorComponent
				:rows="effectiveRows"
				:totalRecords="totalRecords"
				:first="(currentPage - 1) * rows"
				@page="onPageChange($event)"
				:showCurrentPageReport="true"
				template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
				class="justify-between px-3"
			/>
		</div>

		<div class="pagination-mobile px-3">
			<p class="pagination-mobile-report">{{ mobileCurrentPageReport }}</p>
			<PaginatorComponent
				:rows="effectiveRows"
				:totalRecords="totalRecords"
				:first="(currentPage - 1) * rows"
				@page="onPageChange($event)"
				template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
				class="pagination-mobile-controls"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">


const currentDataFilter = ref('') // ose nga props, ose store

const effectiveRows = computed(() => {
	return currentDataFilter.value ? 1 : props.rows
})

const currentFirst = computed(() => {
	if (!props.totalRecords) {
		return 0
	}
	return (props.currentPage - 1) * effectiveRows.value + 1
})

const currentLast = computed(() => {
	if (!props.totalRecords) {
		return 0
	}
	return Math.min(props.currentPage * effectiveRows.value, props.totalRecords)
})

const mobileCurrentPageReport = computed(
	() => `Showing ${currentFirst.value} to ${currentLast.value} of ${props.totalRecords}`
)


const props = withDefaults( defineProps<{
	totalRecords: number
	rows: number
	currentPage: number
	hidePagination?: boolean;

}>(), {
	hidePagination: false,
} )


const emit = defineEmits(['update:currentPage'])

function onPageChange ( event: any ) {
	const scrollY = window.scrollY
	event?.originalEvent?.preventDefault?.()
	emit( 'update:currentPage', event.page + 1 )
	nextTick( () => {
		setTimeout( () => {
			window.scrollTo( { top: scrollY, behavior: 'instant' } )
		}, 10 )
	} )
}
</script>
<style>
	.p-paginator button:focus {
		outline: none !important;
		box-shadow: none !important;
	}

	.p-paginator:focus-within {
		scroll-margin: 0 !important;
	}

	.p-paginator {
		background: transparent !important;
		padding: 0;
	}
	
	.p-paginator .p-paginator-current {
		margin-right: auto !important;
	}

	.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
		background: #c6dcf9 !important;
		border-color: #c6dcf9 !important;
		color: #1D4ED8 !important;
	}

	.pagination-mobile {
		display: none;
	}

	.pagination-mobile-report {
		margin: 0 0 0.55rem;
		font-size: 1rem;
		line-height: 1.35;
		color: #4b5563;
		text-align: center;
	}

	.pagination-mobile-controls.p-paginator {
		display: flex;
		justify-content: center;
		align-items: center;
		column-gap: 0.1rem;
	}

	@media (max-width: 767px) {
		.pagination-desktop {
			display: none;
		}

		.pagination-mobile {
			display: block;
		}

		.pagination-mobile .p-paginator {
			padding-left: 0;
			padding-right: 0;
		}
	}
</style>
